<template>
	<div>
		<buttonlist @help="help" @opentable="opentable" @search="search" @reflash="reflash" @exps="exps" ref="SetBtn"></buttonlist>
		<!-- <el-table
			:data="dataSet"
			v-loading="loading"
			:highlight-current-row="true"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			:height="tableHeight"
			header-row-class-name="headerclass"
			style="width: 100%; margin-top:0px"
			:header-cell-style="$limits.headerClass"
		>
			<el-table-column type="selection" v-if="false"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="order_No" :label="$t('getapi[463]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="row_number" :label="$t('getapi[1425]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Relation_PO_Code" :label="$t('getapi[1710]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="VenderName" :label="$t('getapi[1197]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Pur_Order_Line" :label="$t('getapi[1758]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Requisition_No" :label="$t('getapi[1838]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="delive_order_No" :label="$t('getapi[1744]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="receive_person" :label="$t('getapi[1745]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="receive_Time" :label="$t('getapi[1839]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="create_person" :label="$t('getapi[4470]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="create_Time" :label="$t('getapi[1840]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="batch_No" :label="$t('getapi[1763]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="sequence_No" :label="$t('getapi[1764]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="check_person" :label="$t('getapi[1770]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="check_date" :label="$t('getapi[1841]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="part_code" :label="$t('getapi[112]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="part_name" :label="$t('getapi[116]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="part_version" :label="$t('getapi[149]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="" :label="$t('getapi[1842]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="specification" :label="$t('getapi[125]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="model" :label="$t('getapi[124]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="part_stuff" :label="$t('getapi[126]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="STUFF_MANUF_NAME" :label="$t('getapi[192]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Line_status" :label="$t('getapi[552]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="order_qty" :label="$t('getapi[1843]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Pur_measureunit" :label="$t('getapi[1166]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="actual_qty" :label="$t('getapi[1844]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="wait_check_qty" :label="$t('getapi[1845]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="qualify_qty" :label="$t('getapi[1846]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="disqualify_qty" :label="$t('getapi[1847]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="ought_return_qty" :label="$t('getapi[1848]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="return_qty" :label="$t('getapi[1849]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="receive_qty" :label="$t('getapi[1850]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="check_remark" :label="$t('getapi[1851]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Pur_Reason" :label="$t('getapi[1852]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="transact_person" :label="$t('getapi[1167]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="concedeQty" :label="$t('getapi[1773]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="remark" :label="$t('getapi[143]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="heat_no" :label="$t('getapi[1765]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="After_In_Return_Qty" :label="$t('getapi[6027]')" align="right"></el-table-column>

			<el-table-column show-overflow-tooltip sortable prop="fa_flag" label="FA"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="routing_sequence" :label="$t('getapi[2326]')"></el-table-column>
			<el-table-column show-overflow-tooltip fixed="right" :label="$t('getapi[6048]')" width="120">
				<template slot-scope="scope">
					<el-button @click.native.prevent="lct(scope)" type="text" size="mini">采购业务图</el-button>
				</template>
			</el-table-column>
		</el-table> -->
		<wTable id="xpane-0" :data="dataSet" :loading="loading" :header="tableHeader"
				queryData="PurReceiveLineViewInfo"
				:filter_language="['Line_status','fa_flag']"
				:filter_thousandth="['order_qty','actual_qty','wait_check_qty','qualify_qty','disqualify_qty','ought_return_qty','returned_qty',
				'receive_qty','concedeQty']"
				@handleSelectionChange="handleSelectionChange" :option="tableOption" @lct="lct"  @contextmenu.prevent.native="openMenu($event)"
				ref="singleTable"></wTable>
		<el-row class="page">
				<el-col :span="18">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="pageSize"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-col>
				<el-col :span="6">
					<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
				</el-col>
			</el-row>
		<!-- 改变表格顺序 -->
		<ctable :isVisible="false" :title="$t('getapi[955]')" queryData="PurReceiveLineViewInfo" tabNo="0" ref="ctab" @getctab="sortclick"></ctable>
	
		<serce :isVisible="isVisible" queryData="PurReceiveLineViewInfo" ref="ser" @getser="serclick"></serce>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'purreceivedetailview',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3,
                maxHeight: this.$windowSize.tableHeight3,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('purreceivedetailview'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			tableHeader: [],
            scrollTop:0,
		};
	},
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
		that.colsort();
        that.$nextTick(function(){
            that.$processdata.initForm()
        });
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
		colsort(){
			let that = this;
			that.$loadviewfields.Fileds('PurReceiveLineViewInfo',0,PFileds=>{
			that.tableHeader = PFileds;
		});	
		},
		sortclick(val){
			if(val==1){
				this.colsort();
			}
		},
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[955]"),this.$t("getapi[16]"));
        },
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
			//只读权
			if (that.$limits.ReadOnlyRightsView('plv2', 213, 1, that.total)) {
				if (that.total > 0) {
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
				} else {
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
				}
			}
			//操作权限-查询级别
			var limits = that.$limits.OperationAuthorityView('plv2', 213, 1, that.total);
			// limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
			switch (limits) {
				case -1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				default:
					break;
			}
		},
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('purreceivedetailview',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'PurReceiveLineViewInfo');
		},
		// 修改表格顺序
		opentable(){
			this.$refs.ctab.clearInputs(true);
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				SelectIndex: that.SelectIndexs,
				Param: datac
			};
			that.$http.urlpost('/Pur/Receive/OverViewDataList', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
					that.authority();
                    that.$nextTick(function(){
                        that.$processdata.initForm(0)
                    });
				}
			});
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		// 导出
		exps() {
			/*let that = this;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Ids: '',
				Param: datac
			};
			that.$http.urlpost('/Pur/Receive/OverViewExportToExecl', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
			});*/
            let that = this;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                query_sign: "PurReceiveLineViewInfo",
                fromname: that.$t('getapi[955]'),
                SelectIndex: 0,
                MultyVer: that.$processdata.getLanguage(),
                Param: datac
            };
            that.$processdata.commonExport(parm)
		},
		//销售关系
		lct(row) {
		    let that = this
            that.$store.commit('setSharedParams', row.row);
			let item = {
				label: that.$t('getapi[12345]'),
				name: 'purbusiness',
				path: '/purbusiness/receive',
				url: '/purbusiness/receive',
				icon: 'video-play'
			};
			this.$router.push({ path: '/purbusiness/receive' });
			this.$store.commit('selectMenu', item);
            this.$limits.cachePage(item)
		}
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
